import { Alert, Box, FormControlLabel, styled } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const ItemContainer = styled(Box)`
  display: flex;
  width: 400px;
  padding: 20px 0;
  align-items: center;
  gap: 10px;
`;

export const CheckboxContainer = styled(FormControlLabel)`
  width: 185px;
  margin-right: unset;
`;

export const BackSoonText = styled(Box)`
  display: flex;
  width: 20.625rem;
  align-items: center;
  margin-top: 10px;
`;

export const BackSoon = styled(Box)`
  display: flex;
  width: 400px;
  align-items: center;
`;

export const CustomStyledAlert = styled(Alert)(
  ({ theme }) => `
  background-color:${theme.palette.brand.whitesmoke};
  color: ${theme.palette.brand.charcoal};
  text-align: center;
  `,
);

export const BackSoonContainer = styled(Box)`
  width: 400px;
  padding: 2px 0;
  display: flex;
  align-items: center;
  padding: 2px 0;
`;
